// import React, { useEffect, useState } from "react";
// import axios from "axios";
// import { useAuth } from "../../contexts/AuthContext";
// import { useParams } from "react-router-dom";

// const formatCurrency = (amount) =>
//   Number(amount || 0).toLocaleString("en-US", {
//     minimumFractionDigits: 2,
//     maximumFractionDigits: 2,
//   });

// const formatDate = (d) => {
//   try {
//     return d ? new Date(d).toLocaleDateString("en-US", { year: "numeric", month: "short", day: "numeric" }) : "-";
//   } catch (e) {
//     return String(d || "-");
//   }
// };

// const ReportView = () => {
//   const { user } = useAuth();
//   const { id } = useParams();
//   const studentId = id || user?.userID || user?.userId || user?.UserID;

//   const [data, setData] = useState(null);
//   const [loading, setLoading] = useState(false);
//   const [error, setError] = useState(null);

//   useEffect(() => {
//     if (!studentId) return;
//     (async () => {
//       setLoading(true);
//       setError(null);
//       try {
//         const apiUrl = `http://localhost:50447/api/Reports/student/${studentId}`;
//         const headers = {};
//         try {
//           const rawToken = window.localStorage.getItem("token") || window.sessionStorage.getItem("token");
//           if (rawToken) headers["Authorization"] = `Bearer ${String(rawToken).replace(/^\"|\"$/g, "")}`;
//         } catch (e) {}
//         const resp = await axios.get(apiUrl, { headers });
//         setData(resp.data);
//       } catch (err) {
//         console.error(err);
//         setError(err?.response?.data || err?.message || "Failed to load report");
//       } finally {
//         setLoading(false);
//       }
//     })();
//   }, [studentId]);

//   if (!studentId) {
//     return (
//       <div className="p-6">
//         <div className="text-red-600">Student ID not found.</div>
//       </div>
//     );
//   }

//   return (
//     <div className="min-h-screen p-6 bg-gray-50 dark:bg-gray-900">
//       <div className="max-w-4xl mx-auto">
//         <div className="flex items-center justify-between mb-6">
//           <div>
//             <h1 className="text-2xl font-bold text-gray-900 dark:text-white">Report View</h1>
//             <p className="text-gray-600 dark:text-gray-400 mt-1">Student-level report and payment history</p>
//           </div>
//         </div>

//         {loading ? (
//           <div className="p-6 bg-white dark:bg-gray-800 rounded-lg">Loading...</div>
//         ) : error ? (
//           <div className="p-6 bg-red-50 dark:bg-red-900/20 rounded-lg text-red-600">{String(error)}</div>
//         ) : !data ? (
//           <div className="p-6 bg-white dark:bg-gray-800 rounded-lg">No report available</div>
//         ) : (
//           <div className="space-y-6">
//             <div className="bg-white dark:bg-gray-800 rounded-xl p-6 border border-gray-200 dark:border-gray-700">
//               <div className="flex items-start justify-between">
//                 <div>
//                   <h2 className="text-xl font-semibold text-gray-900 dark:text-white">{data.studentName}</h2>
//                   <div className="text-sm text-gray-500">ID: {data.studentId}</div>
//                   <div className="text-sm text-gray-500">Email: {data.email || '-'}</div>
//                 </div>
//                 <div className="text-right">
//                   <div className="text-sm text-gray-500">Courses</div>
//                   <div className="text-2xl font-bold text-gray-900 dark:text-white">{(data.reports || []).length}</div>
//                 </div>
//               </div>
//             </div>

//             {(data.reports || []).map((r, idx) => (
//               <div key={idx} className="bg-white dark:bg-gray-800 rounded-xl p-6 border border-gray-200 dark:border-gray-700">
//                 <div className="flex items-start justify-between">
//                   <div>
//                     <h3 className="text-lg font-semibold text-gray-900 dark:text-white">{r.courseName}</h3>
//                     <div className="text-sm text-gray-500">Subject: {r.subjectName || '-'}</div>
//                     <div className="text-sm text-gray-500 mt-1">Start: {formatDate(r.startDate)}</div>
//                   </div>
//                   <div className="text-right">
//                     {r.payment ? (
//                       <>
//                         <div className="text-sm text-gray-500">Total</div>
//                         <div className="text-lg font-bold text-gray-900 dark:text-white">{formatCurrency(r.payment.totalAmount)} LKR</div>
//                         <div className="text-sm text-green-600">Paid: {formatCurrency(r.payment.paidAmount)} LKR</div>
//                         <div className="text-sm text-red-600">Balance: {formatCurrency(r.payment.balanceAmount)} LKR</div>
//                         <div className="text-xs mt-2 inline-flex px-2 py-1 rounded bg-gray-100 dark:bg-gray-700 text-gray-600">{r.payment.status}</div>
//                       </>
//                     ) : (
//                       <div className="text-sm text-gray-500">No payment record</div>
//                     )}
//                   </div>
//                 </div>

//                 {r.payment && Array.isArray(r.payment.paymentHistory) && r.payment.paymentHistory.length > 0 && (
//                   <div className="mt-4 border-t border-gray-100 dark:border-gray-700 pt-4 space-y-3">
//                     {r.payment.paymentHistory.map((h) => (
//                       <div key={h.paymentHistoryID} className="p-3 bg-gray-50 dark:bg-gray-900 rounded">
//                         <div className="flex items-start justify-between">
//                           <div>
//                             <div className="text-sm text-gray-600">{formatDate(h.paymentDate)}</div>
//                             <div className="text-xs text-gray-400">Method: {h.paymentMethod} • Ref: {h.referenceNo}</div>
//                             {h.remarks && <div className="text-sm text-gray-700 dark:text-gray-300 mt-2">{h.remarks}</div>}
//                           </div>
//                           <div className="text-right">
//                             <div className="text-lg font-semibold text-green-600">{formatCurrency(h.amountPaid)} LKR</div>
//                           </div>
//                         </div>
//                       </div>
//                     ))}
//                   </div>
//                 )}
//               </div>
//             ))}
//           </div>
//         )}
//       </div>
//     </div>
//   );
// };

// export default ReportView;



import React, { useEffect, useState, useRef } from "react";
import axios from "axios";
import { useAuth } from "../../contexts/AuthContext";
import { useParams } from "react-router-dom";
import { 
  Download, 
  User, 
  Mail, 
  Calendar, 
  DollarSign, 
  CreditCard,
  FileText,
  CheckCircle,
  Clock,
  AlertCircle,
  RefreshCw,
  BookOpen
} from "lucide-react";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";

const formatCurrency = (amount) =>
  Number(amount || 0).toLocaleString("en-US", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

const formatDate = (d) => {
  try {
    return d
      ? new Date(d).toLocaleDateString("en-US", {
          year: "numeric",
          month: "short",
          day: "numeric",
        })
      : "-";
  } catch (e) {
    return String(d || "-");
  }
};

const getPaymentStatusIcon = (status) => {
  switch (status?.toUpperCase()) {
    case "PAID":
      return <CheckCircle className="w-3 h-3 text-green-600 dark:text-green-400 shrink-0" />;
    case "PARTIAL":
      return <Clock className="w-3 h-3 text-amber-600 dark:text-amber-400 shrink-0" />;
    case "UNPAID":
      return <AlertCircle className="w-3 h-3 text-red-600 dark:text-red-400 shrink-0" />;
    default:
      return <FileText className="w-3 h-3 text-gray-400 shrink-0" />;
  }
};

const getPaymentStatusColor = (status) => {
  switch (status?.toUpperCase()) {
    case "PAID":
      return "bg-green-100 text-green-800 dark:bg-green-900/40 dark:text-green-300 border-green-200 dark:border-green-800/40";
    case "PARTIAL":
      return "bg-amber-100 text-amber-800 dark:bg-amber-900/40 dark:text-amber-300 border-amber-200 dark:border-amber-800/40";
    case "UNPAID":
      return "bg-red-100 text-red-800 dark:bg-red-900/40 dark:text-red-300 border-red-200 dark:border-red-800/40";
    default:
      return "bg-gray-100 text-gray-800 dark:bg-gray-700 dark:text-gray-300 border-gray-200 dark:border-gray-600";
  }
};

const ReportView = () => {
  const { user } = useAuth();
  const { id } = useParams();
  const studentId = id || user?.userID || user?.userId || user?.UserID;

  const reportRef = useRef();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [exporting, setExporting] = useState(false);

  useEffect(() => {
    if (!studentId) return;
    fetchReportData();
  }, [studentId]);

  const fetchReportData = async () => {
    setLoading(true);
    setError(null);
    try {
      const apiUrl = `https://testtuitionbackend.dockyardsoftware.com/api/Reports/student/${studentId}`;
      const headers = {};
      try {
        const rawToken =
          window.localStorage.getItem("token") || window.sessionStorage.getItem("token");
        if (rawToken)
          headers["Authorization"] = `Bearer ${String(rawToken).replace(/^"|"$/g, "")}`;
      } catch (e) {}
      const resp = await axios.get(apiUrl, { headers });
      setData(resp.data);
    } catch (err) {
      console.error(err);
      setError(err?.response?.data || err?.message || "Failed to load report");
    } finally {
      setLoading(false);
    }
  };

  const exportToPDF = async () => {
    if (!reportRef.current || exporting) return;

    setExporting(true);
    try {
      const element = reportRef.current;

      const buttons = element.querySelectorAll("button");
      const originalDisplay = [];
      buttons.forEach((btn) => {
        originalDisplay.push(btn.style.display);
        btn.style.display = "none";
      });

      const canvas = await html2canvas(element, {
        scale: 2,
        useCORS: true,
        logging: false,
        backgroundColor: "#ffffff",
      });

      buttons.forEach((btn, i) => {
        btn.style.display = originalDisplay[i];
      });

      const imgData = canvas.toDataURL("image/png");
      const pdf = new jsPDF("p", "mm", "a4");
      const pdfWidth = pdf.internal.pageSize.getWidth();
      const pdfHeight = pdf.internal.pageSize.getHeight();

      const imgWidth = canvas.width;
      const imgHeight = canvas.height;
      const ratio = imgHeight / imgWidth;

      let width = pdfWidth - 20;
      let height = width * ratio;

      if (height > pdfHeight) {
        height = pdfHeight - 20;
        width = height / ratio;
      }

      pdf.addImage(imgData, "PNG", 10, 10, width, height);
      pdf.save(
        `student-report-${studentId}-${new Date().toISOString().split("T")[0]}.pdf`
      );
    } catch (error) {
      console.error("PDF export failed:", error);
      alert("Failed to export PDF. Please try again.");
    } finally {
      setExporting(false);
    }
  };

  const calculateTotalStats = () => {
    if (!data?.reports) return { totalCourses: 0, totalPaid: 0, totalBalance: 0 };

    return data.reports.reduce(
      (acc, report) => {
        if (report.payment) {
          acc.totalPaid += report.payment.paidAmount || 0;
          acc.totalBalance += report.payment.balanceAmount || 0;
        }
        return acc;
      },
      {
        totalCourses: data.reports.length,
        totalPaid: 0,
        totalBalance: 0,
      }
    );
  };

  if (!studentId) {
    return (
      <div className="text-center py-8 bg-white dark:bg-gray-800 rounded-xl border border-gray-200 dark:border-gray-700 p-4">
        <AlertCircle className="w-8 h-8 mx-auto text-red-500 mb-2" />
        <div className="text-xs font-semibold text-red-600 dark:text-red-400">
          Student ID not found.
        </div>
      </div>
    );
  }

  const stats = calculateTotalStats();

  return (
    <div className="w-full space-y-3 sm:space-y-4">
      {/* Header */}
      <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-2.5 pb-1">
        <div>
          <h1 className="text-base sm:text-lg md:text-xl font-bold text-gray-900 dark:text-white flex items-center gap-2">
            <FileText className="w-4 h-4 sm:w-5 sm:h-5 text-indigo-600 dark:text-indigo-400 shrink-0" />
            Student Report
          </h1>
          <p className="text-[11px] sm:text-xs text-gray-500 dark:text-gray-400 mt-0.5">
            Detailed payment history and course enrollment progress
          </p>
        </div>

        <div className="flex items-center gap-1.5 self-start sm:self-auto shrink-0">
          <button
            onClick={fetchReportData}
            disabled={loading}
            className="px-2.5 sm:px-3 py-1.5 text-xs bg-gray-100 dark:bg-gray-800 text-gray-700 dark:text-gray-300 rounded-lg hover:bg-gray-200 dark:hover:bg-gray-700 transition-colors flex items-center gap-1.5 font-medium shadow-xs"
            title="Refresh report"
          >
            <RefreshCw className={`w-3.5 h-3.5 ${loading ? "animate-spin" : ""}`} />
            <span>Refresh</span>
          </button>

          <button
            onClick={exportToPDF}
            disabled={!data || exporting}
            className="px-2.5 sm:px-3 py-1.5 text-xs bg-indigo-600 hover:bg-indigo-700 text-white rounded-lg transition-colors flex items-center gap-1.5 font-medium shadow-xs disabled:opacity-50"
          >
            <Download className="w-3.5 h-3.5" />
            <span>{exporting ? "Exporting..." : "Export PDF"}</span>
          </button>
        </div>
      </div>

      {loading ? (
        <div className="text-center py-8 bg-white dark:bg-gray-800 rounded-xl border border-gray-200 dark:border-gray-700 p-4">
          <div className="inline-block animate-spin rounded-full h-8 w-8 border-t-2 border-b-2 border-indigo-600"></div>
          <p className="mt-2 text-xs text-gray-500 dark:text-gray-400">Loading report data...</p>
        </div>
      ) : error ? (
        <div className="bg-red-50 dark:bg-red-900/20 border border-red-200 dark:border-red-800 rounded-xl p-3.5 text-center">
          <p className="text-xs text-red-600 dark:text-red-400 font-medium">{String(error)}</p>
          <button
            onClick={fetchReportData}
            className="mt-2 px-3 py-1 bg-red-600 text-white text-xs rounded-lg hover:bg-red-700 transition-colors"
          >
            Try Again
          </button>
        </div>
      ) : !data ? (
        <div className="text-center py-8 bg-white dark:bg-gray-800 rounded-xl border border-gray-200 dark:border-gray-700 p-4">
          <FileText className="w-10 h-10 mx-auto text-gray-400 dark:text-gray-600 mb-2" />
          <h3 className="text-sm font-semibold text-gray-900 dark:text-white mb-1">
            No Report Available
          </h3>
          <p className="text-xs text-gray-500 dark:text-gray-400">
            No report data found for this student.
          </p>
        </div>
      ) : (
        <div ref={reportRef} className="space-y-3 sm:space-y-4">
          {/* Student Info Card */}
          <div className="bg-white dark:bg-gray-800 rounded-xl p-3 sm:p-4 shadow-xs border border-gray-200/90 dark:border-gray-700">
            <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-3">
              <div className="flex items-center gap-2.5 min-w-0">
                <div className="w-8 h-8 rounded-lg bg-indigo-50 dark:bg-indigo-900/30 text-indigo-600 dark:text-indigo-400 flex items-center justify-center shrink-0">
                  <User className="w-4 h-4" />
                </div>
                <div className="min-w-0">
                  <div className="flex items-center gap-1.5 flex-wrap">
                    <h2 className="text-xs sm:text-sm md:text-base font-bold text-gray-900 dark:text-white truncate">
                      {data.studentName}
                    </h2>
                    <span className="px-1.5 py-0.2 text-[10px] bg-gray-100 dark:bg-gray-700 text-gray-600 dark:text-gray-400 rounded shrink-0">
                      ID: {data.studentId}
                    </span>
                  </div>
                  {data.email && (
                    <div className="flex items-center gap-1 text-[11px] text-gray-500 dark:text-gray-400 mt-0.5 truncate">
                      <Mail className="w-3 h-3 text-gray-400 shrink-0" />
                      <span className="truncate">{data.email}</span>
                    </div>
                  )}
                </div>
              </div>

              {/* 3 Metric Badges */}
              <div className="grid grid-cols-3 gap-1.5 sm:gap-2 shrink-0">
                <div className="bg-gray-50/70 dark:bg-gray-900/40 p-1.5 sm:p-2 rounded-lg border border-gray-100 dark:border-gray-800 text-center min-w-[72px]">
                  <div className="text-[10px] font-semibold text-gray-500 uppercase">Courses</div>
                  <div className="text-xs sm:text-sm font-bold text-gray-900 dark:text-white mt-0.5">
                    {stats.totalCourses}
                  </div>
                </div>

                <div className="bg-green-50/70 dark:bg-green-900/20 p-1.5 sm:p-2 rounded-lg border border-green-100/60 dark:border-green-800/30 text-center min-w-[72px]">
                  <div className="text-[10px] font-semibold text-green-600 dark:text-green-400 uppercase">
                    Paid
                  </div>
                  <div
                    className="text-xs sm:text-sm font-bold text-green-600 dark:text-green-400 mt-0.5 truncate"
                    title={`${formatCurrency(stats.totalPaid)} LKR`}
                  >
                    {formatCurrency(stats.totalPaid)}
                  </div>
                </div>

                <div className="bg-amber-50/70 dark:bg-amber-900/20 p-1.5 sm:p-2 rounded-lg border border-amber-100/60 dark:border-amber-800/30 text-center min-w-[72px]">
                  <div className="text-[10px] font-semibold text-amber-600 dark:text-amber-400 uppercase">
                    Balance
                  </div>
                  <div
                    className="text-xs sm:text-sm font-bold text-amber-600 dark:text-amber-400 mt-0.5 truncate"
                    title={`${formatCurrency(stats.totalBalance)} LKR`}
                  >
                    {formatCurrency(stats.totalBalance)}
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Courses List */}
          <div className="space-y-2.5 sm:space-y-3">
            {(data.reports || []).map((report, idx) => (
              <div
                key={idx}
                className="bg-white dark:bg-gray-800 rounded-xl shadow-xs overflow-hidden border border-gray-200/90 dark:border-gray-700"
              >
                {/* Course Header */}
                <div className="p-2.5 sm:p-3.5 border-b border-gray-100 dark:border-gray-700/80">
                  <div className="flex flex-col sm:flex-row sm:items-start justify-between gap-2">
                    <div className="min-w-0 flex-1">
                      <div className="flex items-center gap-1.5">
                        <BookOpen className="w-3.5 h-3.5 text-indigo-600 dark:text-indigo-400 shrink-0" />
                        <h3 className="text-xs sm:text-sm font-bold text-gray-900 dark:text-white truncate">
                          {report.courseName}
                        </h3>
                      </div>
                      <div className="flex flex-wrap items-center gap-x-2 gap-y-0.5 mt-1 text-[11px] text-gray-500 dark:text-gray-400">
                        {report.subjectName && (
                          <span>Class: {report.subjectName}</span>
                        )}
                        {report.startDate && (
                          <>
                            <span>•</span>
                            <span className="flex items-center gap-0.5">
                              <Calendar className="w-3 h-3 text-gray-400" />
                              Start: {formatDate(report.startDate)}
                            </span>
                          </>
                        )}
                      </div>
                    </div>

                    {report.payment && (
                      <span
                        className={`self-start sm:self-auto inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-[10px] sm:text-xs font-medium border shrink-0 ${getPaymentStatusColor(
                          report.payment.status
                        )}`}
                      >
                        {getPaymentStatusIcon(report.payment.status)}
                        <span>{report.payment.status || "UNKNOWN"}</span>
                      </span>
                    )}
                  </div>
                </div>

                {/* 3 Metric Tiles (Total, Paid, Balance) */}
                {report.payment ? (
                  <div className="p-2 sm:p-2.5 m-2.5 sm:m-3 mb-2.5 bg-gray-50/70 dark:bg-gray-900/40 rounded-lg grid grid-cols-3 gap-1.5 sm:gap-2 border border-gray-100/80 dark:border-gray-800">
                    <div className="text-center min-w-0">
                      <div className="text-[10px] text-gray-500 uppercase font-semibold">Total</div>
                      <div
                        className="text-xs sm:text-sm md:text-base font-bold text-gray-900 dark:text-white mt-0.5 truncate"
                        title={`${formatCurrency(report.payment.totalAmount)} LKR`}
                      >
                        {formatCurrency(report.payment.totalAmount)} LKR
                      </div>
                    </div>

                    <div className="text-center min-w-0 border-x border-gray-200 dark:border-gray-700/60 px-1">
                      <div className="text-[10px] text-gray-500 uppercase font-semibold">Paid</div>
                      <div
                        className="text-xs sm:text-sm md:text-base font-bold text-green-600 dark:text-green-400 mt-0.5 truncate"
                        title={`${formatCurrency(report.payment.paidAmount)} LKR`}
                      >
                        {formatCurrency(report.payment.paidAmount)} LKR
                      </div>
                    </div>

                    <div className="text-center min-w-0">
                      <div className="text-[10px] text-gray-500 uppercase font-semibold">Balance</div>
                      <div
                        className={`text-xs sm:text-sm md:text-base font-bold mt-0.5 truncate ${
                          report.payment.balanceAmount > 0
                            ? "text-red-500 dark:text-red-400"
                            : "text-green-600 dark:text-green-400"
                        }`}
                        title={`${formatCurrency(report.payment.balanceAmount)} LKR`}
                      >
                        {formatCurrency(report.payment.balanceAmount)} LKR
                      </div>
                    </div>
                  </div>
                ) : (
                  <div className="p-3 text-center text-xs text-gray-400 dark:text-gray-500">
                    No payment record available for this course.
                  </div>
                )}

                {/* Payment History Section */}
                {report.payment &&
                  Array.isArray(report.payment.paymentHistory) &&
                  report.payment.paymentHistory.length > 0 && (
                    <div className="p-2.5 sm:p-3 bg-gray-50/50 dark:bg-gray-900/30 border-t border-gray-100 dark:border-gray-700/80 space-y-2">
                      <div className="flex items-center justify-between">
                        <h4 className="text-xs font-semibold text-gray-900 dark:text-white flex items-center gap-1.5">
                          <CreditCard className="w-3.5 h-3.5 text-indigo-500" />
                          <span>Payment History</span>
                          <span className="text-[10px] text-gray-500 dark:text-gray-400">
                            ({report.payment.paymentHistory.length})
                          </span>
                        </h4>
                      </div>

                      <div className="space-y-1.5 max-h-40 overflow-y-auto pr-0.5">
                        {report.payment.paymentHistory.map((history, hIdx) => (
                          <div
                            key={history.paymentHistoryID || hIdx}
                            className="bg-white dark:bg-gray-800 rounded-lg p-2 border border-gray-100 dark:border-gray-700 text-xs"
                          >
                            <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-1">
                              <div className="min-w-0">
                                <div className="flex items-center gap-1.5">
                                  <span className="flex items-center justify-center w-4 h-4 rounded-full bg-indigo-100 dark:bg-indigo-900/40 text-indigo-600 dark:text-indigo-400 font-bold text-[9px] shrink-0">
                                    {hIdx + 1}
                                  </span>
                                  <span className="font-semibold text-gray-800 dark:text-gray-200 truncate text-[11px] sm:text-xs">
                                    {history.remarks || "Payment"}
                                  </span>
                                </div>
                                <div className="flex flex-wrap items-center gap-1.5 text-[10px] text-gray-500 dark:text-gray-400 mt-0.5">
                                  <span>{formatDate(history.paymentDate)}</span>
                                  <span className="px-1.5 py-0.2 bg-gray-100 dark:bg-gray-700 rounded font-medium text-gray-600 dark:text-gray-300">
                                    {history.paymentMethod}
                                  </span>
                                  {history.referenceNo && (
                                    <>
                                      <span>•</span>
                                      <span>Ref: {history.referenceNo}</span>
                                    </>
                                  )}
                                </div>
                              </div>

                              <div className="text-left sm:text-right pt-1 sm:pt-0 border-t sm:border-t-0 border-gray-100 dark:border-gray-700 shrink-0">
                                <span className="text-xs sm:text-sm font-bold text-green-600 dark:text-green-400">
                                  {formatCurrency(history.amountPaid)} LKR
                                </span>
                              </div>
                            </div>
                          </div>
                        ))}
                      </div>

                      {/* Mini Progress */}
                      <div className="p-2 bg-white dark:bg-gray-800 rounded-lg border border-gray-100 dark:border-gray-700">
                        <div className="flex items-center justify-between text-[11px] text-gray-600 dark:text-gray-400 mb-1">
                          <span>Payment Progress</span>
                          <span className="font-bold text-gray-900 dark:text-white">
                            {Math.round(
                              (report.payment.paidAmount / report.payment.totalAmount) * 100
                            )}
                            %
                          </span>
                        </div>
                        <div className="w-full h-1.5 bg-gray-100 dark:bg-gray-700 rounded-full overflow-hidden">
                          <div
                            className="bg-green-500 h-1.5 rounded-full transition-all duration-300"
                            style={{
                              width: `${Math.min(
                                100,
                                (report.payment.paidAmount / report.payment.totalAmount) * 100
                              )}%`,
                            }}
                          ></div>
                        </div>
                      </div>
                    </div>
                  )}
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default ReportView;